@if (visible) {
  <section id="{{ renderMode }}" class="{{ originNamespace }}-namespace">
    <div class="mip-container">
      <div class="title">{{ title }}</div>
      <div class="container">
        <mat-icon [fontIcon]="icon" [ngClass]="icon"></mat-icon>
        {{ text }}
      </div>
    </div>
    <span class="kyloe-watermark"></span>
  </section>
}
